import { useFormikContext } from 'formik';

import RadioButton from 'components/shared/RadioButton/RadioButton';

const options = [
  { label: 'Current Page', value: 'current' },
  { label: 'All Pages', value: 'all' }
];

const ExportPageScope = () => {
  const { values, setFieldValue } = useFormikContext();

  return (
    <div>
      <label className="m-0 text-sm font-500 text-neutral-800 first-letter:capitalize">
        Export Rows
      </label>

      <div className="mt-2 flex gap-4">
        {options.map((option) => (
          <RadioButton
            key={option.value}
            dataQA={`radio-export-scope-${option.value}`}
            size="medium"
            isSelected={values.export_scope === option.value}
            onChange={() => setFieldValue('export_scope', option.value)}
            label={option.label}
            name="export_scope"
            wrapperClassName="w-max"
          />
        ))}
      </div>
    </div>
  );
};

export default ExportPageScope;
